import {
    SET_IS_HYBRID_APP,
    ADD_HYBRID_APP_REG_OTP_RESPONSE,
    RESET_HYBRID_APP_REG_OTP_RESPONSE,
    SET_OTP_FROM_NATIVE,
    CLEAR_OTP_FROM_NATIVE,
    SET_HYBRID_APP_CHECKOUT,
    RESET_HYBRID_APP_CHECKOUT,
    RESET_HYBRID_APP
} from '../../actions/V2_0/hybridAppAction';

const initialState = {
    isHybridApp: false,
    registrationOTPResponse: null,
    otpFromNative: null,
    checkout: {
        deliveryOptionId: null,
        refundOptionId: null,
        isDefaultRefundOption: null,
        deliveryDate: null,
        deliveryDateLabel: null,
        deliveryTime: null,
        deliveryTimeLabel: null,
        deliveryDateTime: null,
        pickupName: "",
        pickupMobile: "",
        pickupDate: null,
        pickupDateLabel: null,
        pickupTime: null,
        pickupTimeLabel: null,
        pickupDateTime: null,
        pickupNotes: "",
        promoCode: null,
        paymentMethod: null,
    },
};

export const hybridAppReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_IS_HYBRID_APP:
            return {
                ...state,
                isHybridApp: action.payload,
            };

        case ADD_HYBRID_APP_REG_OTP_RESPONSE:
            return {
                ...state,
                registrationOTPResponse: action.payload,
            };

        case RESET_HYBRID_APP_REG_OTP_RESPONSE:
            return {
                ...state,
                registrationOTPResponse: null,
            };

        case SET_OTP_FROM_NATIVE:
            return {
                ...state,
                otpFromNative: action.payload,
            };

        case CLEAR_OTP_FROM_NATIVE:
            return {
                ...state,
                otpFromNative: null,
            };

        case SET_HYBRID_APP_CHECKOUT:
            return {
                ...state,
                checkout: {
                    ...state.checkout,
                    ...action.payload,
                },
            };

        case RESET_HYBRID_APP_CHECKOUT:
            return {
                ...state,
                checkout: initialState.checkout,
            };

        case RESET_HYBRID_APP:
            return {
                isHybridApp: state.isHybridApp,
                registrationOTPResponse: initialState.registrationOTPResponse,
                checkout: initialState.checkout,
            };

        default:
            return state;
    }
};
